import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { enterAnimation } from '../../animations/fade.animations';
import { LoaderService } from '../loader.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [enterAnimation]
})
export class LoadingComponent implements OnInit {
  isVisible = 0;
  constructor(private load: LoaderService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.load.controler$.subscribe(res => {
      this.isVisible += res;
      this.cdr.detectChanges();
    });
  }
}
